import { useEffect } from "react";

function setMeta(attr, value, content) {
  let el = document.querySelector(`meta[${attr}="${value}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, value);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href, extra = {}) {
  const selector = extra.hreflang
    ? `link[rel="${rel}"][hreflang="${extra.hreflang}"]`
    : `link[rel="${rel}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    if (extra.hreflang) el.setAttribute("hreflang", extra.hreflang);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// opts: { title, description, canonical, keywords, ogImage, ogType, jsonLd, noindex }
export function useSEO(opts = {}) {
  const { title, description, canonical, keywords, ogImage, ogType, jsonLd, noindex } = opts;

  useEffect(() => {
    const url = canonical || window.location.href.split("?")[0];

    if (title)       document.title = title;
    if (description) setMeta("name", "description", description);
    if (keywords)    setMeta("name", "keywords", keywords);
    // robots — noindex,follow on thin pages avoids HCS doorway demotion sitewide.
    setMeta("name", "robots", noindex ? "noindex, follow" : "index, follow");

    // Open Graph
    if (title)       setMeta("property", "og:title", title);
    if (description) setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", ogType || "website");
    setMeta("property", "og:site_name", "9achna");
    setMeta("property", "og:locale", "fr_DZ");
    setMeta("property", "og:locale:alternate", "ar_DZ");
    if (ogImage) setMeta("property", "og:image", ogImage);

    // Twitter Card
    setMeta("name", "twitter:card", "summary_large_image");
    if (title)       setMeta("name", "twitter:title", title);
    if (description) setMeta("name", "twitter:description", description);
    if (ogImage)     setMeta("name", "twitter:image", ogImage);

    // Canonical + hreflang
    setLink("canonical", url);
    setLink("alternate", url, { hreflang: "fr-DZ" });
    setLink("alternate", url, { hreflang: "ar-DZ" });
    setLink("alternate", url, { hreflang: "x-default" });

    // JSON-LD structured data
    const SCRIPT_ID = "seo-jsonld";
    let script = document.getElementById(SCRIPT_ID);
    if (jsonLd) {
      if (!script) {
        script = document.createElement("script");
        script.id = SCRIPT_ID;
        script.type = "application/ld+json";
        document.head.appendChild(script);
      }
      script.textContent = JSON.stringify(jsonLd);
    } else if (script) {
      script.remove();
    }
  }, [title, description, canonical, keywords, ogImage, ogType, jsonLd, noindex]);
}
